// Office switchboards verified against LOGA's Telefon geschäftl. column.
// Match the complete switchboard rather than guessing an extension length.
const officeNumbers = [
    ["0711", "21068"],
    ["0351", "25518"],
    ["07131", "9640"],
    ["0761", "2928137"],
    ["0711", "577499"],
    ["03763", "4400"],
] as const;

export function teamsPhoneCallUrl(value: string): string {
    const digits = value.trim().replace(/^(\+49|0049)\s*\(0\)/, "$1").replace(/[^+\d]/g, "");
    if (!/^\+?\d+$/.test(digits)) return "";
    const international = digits.startsWith("00") ? `+${digits.slice(2)}`
        : digits.startsWith("0") ? `+49${digits.slice(1)}` : digits;
    return `msteams://teams.microsoft.com/l/call/0/0?users=${encodeURIComponent(`4:${international}`)}`;
}

export function formatGermanPhone(value: unknown): string {
    const raw = String(value ?? "").trim();
    if (!raw) return "";
    // Leave foreign numbers and non-number text as supplied.
    if (!/^[+\d\s()/–—-]+$/.test(raw)
        || (raw.startsWith("+") && !raw.startsWith("+49"))
        || (raw.startsWith("00") && !raw.startsWith("0049"))) return raw;
    const digits = raw.replace(/\D/g, "").replace(/^(?:0049|49)/, "0");
    for (const [area, switchboard] of officeNumbers) {
        const prefix = area + switchboard;
        if (digits.startsWith(prefix)) {
            const extension = digits.slice(prefix.length);
            if (/^\d{1,4}$/.test(extension)) return `${area} ${switchboard}-${extension}`;
        }
    }
    // Mobile numbers have no office extension. Preserve the supplied grouping.
    return raw.replace(/^\+49[\s/]*(?:\(0\))?\s*/, "0")
        .replace(/^0049[\s/]*(?:\(0\))?\s*/, "0").replace(/^0\s*/, "0");
}
